import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDimensions } from '@libs/hooks';
import { screenSizes } from '@libs/theme';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import Copy from '../../copy/Copy';
import { ExportButton } from '../../export-button/ExportButton';
import { CustomDropDown, InfoWrapper, Row, Title, Desc, Wrapper, ButtonWrapper, } from './styles';
export const SwapTaskInfo = ({ isOpen, title, rows, shouldIconShow = true, className, isNotCloseable, buttonTextBeforeCopying, buttonTextAfterCopying, }) => {
    const [isOpened, setIsOpened] = useState(isOpen);
    const handleClick = () => {
        if (isNotCloseable)
            return;
        setIsOpened((prev) => !prev);
    };
    const { colors } = useTheme();
    const { width } = useDimensions();
    return (_jsx(CustomDropDown, { isOpen: isOpened, title: title, onClick: handleClick, shouldIconShow: shouldIconShow, className: className, children: _jsx(InfoWrapper, { children: rows.map((row, index) => {
                const renderItem = !!row.desc &&
                    (typeof row.desc === 'string' ? (_jsx(Desc, { fontFamily: "primaryBold", type: width >= screenSizes.tabletL ? 'subHeadline' : 'bodyButton', color: colors.text.default, children: row.desc })) : (row.desc));
                return (_jsxs(Row, { children: [_jsx(Title, { type: width >= screenSizes.tabletL ? 'subHeadline' : 'bodyButton', color: colors.text.secondary, children: row.title }), _jsx(Wrapper, { children: _jsxs(ButtonWrapper, { children: [renderItem, row.shouldCopyButtonRender && (_jsx(Copy, { text: row.desc, buttonTextAfterCopying: buttonTextAfterCopying, buttonTextBeforeCopying: buttonTextBeforeCopying, backgroundColor: colors.surface.default })), row.shouldExportButtonRender && (_jsx(ExportButton, { handleClick: () => null }))] }) })] }, index));
            }) }) }));
};
export default SwapTaskInfo;
//# sourceMappingURL=SwapTaskInfo.js.map